const formalToLocalizedDescription = (labels) => {
  return labels.reduce((acc, label) => {
    return {
      ...acc,
      [label.locale]: label.value
    };
  }, {});
};
const isShippingMethodFree = (cartPrice, freeAbove, shippingPrice) => {
  if (shippingPrice === 0) return true;
  if (freeAbove) {
    return freeAbove <= cartPrice;
  }
  return false;
};
const mapShippingMethods = (shippingMethodList, cartPrice) => {
  return shippingMethodList ? shippingMethodList.map((shippingMethod) => {
    return {
      id: shippingMethod.id,
      key: shippingMethod.key,
      price: shippingMethod.price,
      freeAbove: shippingMethod.freeAbove,
      isFree: isShippingMethodFree(cartPrice, shippingMethod.freeAbove, shippingMethod.price),
      isDefault: shippingMethod.isDefault,
      localizedDescription: shippingMethod.label && shippingMethod.label.length ? formalToLocalizedDescription(shippingMethod.label) : {}
    };
  }) : [];
};
export {
  isShippingMethodFree,
  mapShippingMethods
};
//# sourceMappingURL=shipping-methods.js.map
